import { useEffect, useContext, useCallback } from "react";
import { observer } from "mobx-react";
import { StoreContext } from "../contexts/Store";
import { useLocation } from "react-router-dom";
import { getFeatureFromRoute, trackEvent } from "../helpers";
import { ADMIN_PANEL, MENU } from "../constants";

function DataLoader() {
  const mainStore = useContext(StoreContext);
  const location = useLocation();
  const featureName = getFeatureFromRoute(location);
  const partsURL = location.pathname.split("/");
  const lastIndex = partsURL.length - 1;
  const userID = partsURL[lastIndex];
  const params = new URLSearchParams(location.search);
  const establishmentId = params.get("establishmentId");

  useEffect(() => {
    const html = document.documentElement;
    if (location.pathname.startsWith("/ua")) {
      html.setAttribute("lang", "uk");
    }
  }, [location]);

  useEffect(() => {
    trackEvent("page_view", {
      page_location: window.location.href,
      page_path: location.pathname,
      page_title: document.title,
      feature: featureName,
    });
  }, [location.pathname, location.search, featureName]);

  const fetchData = useCallback(async () => {
    switch (featureName) {
      case ADMIN_PANEL:
        await mainStore.subscription.index();
        await mainStore.establishments.index();
        await mainStore.settings.index();
        break;
      case MENU:
        await mainStore.menu.index(userID, establishmentId);
        break;
      default:
        break;
    }
  }, [featureName, mainStore, userID, establishmentId]);

  useEffect(() => {
    void fetchData();
  }, [featureName, fetchData]);

  return null;
}

export default observer(DataLoader);
